import { InfoBo, QueovalBase, Select } from "../../models";

export class FormationModel extends QueovalBase {
  public ListColPipe: Array<ColumnPipe>;
  public ListTraining: Array<Training>;
  public ListAction: Array<ActionForm>;
  public ListSession: Array<Session>;
  public ListCourseTypes: Array<Select>;
  public ListGeneralGoals: Array<Select>;
  public SelectedTraining: Training;
  public SelectedAction: ActionForm;
  public SelectedSession: Session;
  public SelectedColumnPipe: ColumnPipe;
  public FormationDefault: Training;
  public ResultXML: string;
  public FileTitleXML: string;
  public WarningEdof: WarningEdof;
  //  public TextVerif: string;
}


export class ActionForm {
  public Ident: string;
  public Code: string;
  public Title: string;
  public InfoBoAction: InfoBo;
  public IsModeEdition: boolean;
  public ListSession: Array<Session>;
  public ShowListSession: boolean;
  public InfoBoNewSession: InfoBo;
  public ShowBoNewSession: boolean;
  public Quantite: string;
  public Unite: string;
  public TotalHT: string;
  public Url: string;
  public NbSession: number;

}

export class ColumnPipe {
  public Ident: string;
  public Code: string;
  public Title: string;
  public ListTraining: Array<Training>;
  public IsModeEdit: boolean;
} 


export class Session {
  public Ident: string;
  public Code: string;
  public State: string;
  public LibelleState: string;
  public IsModeEdition: boolean;
  public InfoBoSession: InfoBo;

  // Pour l'export EDOF
  public IdentTraining: string;
  public IdentAction: string;
  public TypeSession: string;
  public IsExportEdof: boolean;
  public TextVerifSession: string;
}

export class Training {
  public Ident: string;
  public Title: string;
  public Description: string;
  public Code: string;
  public Goal: string;
  public Result: string;
  public Content: string;
  public Highlights: string;
  public GeneralGoal: string;
  public CourseType: string;
  public StrDateMaj: string;
  //  public WithSessionEdof: boolean;
  public InfoBoTraining: InfoBo;
  public InfoBoNewAction: InfoBo;
  public ColumnPipe: string;
  public StrImage: string;
  public NbAction: number;
  public IsFormationDefault: boolean;
  //Front variable
  public isDragging: boolean;
}

export class WarningEdof {
  public ListControlError: Array<ControlErrorEdof>;
  public FullTextVerif: string;
}

export class ControlErrorEdof {
  public ColTraining: string;
  public Training: string;
  public Action: string;
  public Session: string;
  public AttributName: string;
  public ExtraInfos: string;
  public ErrorMsg: string;
}
